import React, { useEffect, useRef, useState } from 'react';
import { Button, Text, View, Modal, FormControl } from 'native-base';
import { liveTTScoreboardButtonTextColor, liveTTScoreboardColor } from '../../../livettscoreboard.config';
import { setUsedTimeOut, startTimeOut } from '../functions/scoring';
import { getCombinedPlayerNames } from '../functions/players';
import { openBrowserAsync } from 'expo-web-browser';
import { setStringAsync } from 'expo-clipboard';
export function ScoreboardMessageModal(props) {


    return (
        <Modal onClose={() => { props.onClose(); }} isOpen={props.isOpen}>
            <Modal.Content>
                <Modal.CloseButton></Modal.CloseButton>
                <Modal.Header>Edit Scoreboard</Modal.Header>
                <Modal.Body>
                    <Text>This editor is only supported on a computer, mobile devices might not work as intended.</Text>
                    <View padding={1}
                    >
                        <Button onPress={() => {
                            openBrowserAsync(props.editorURL);
                        }}>
                            <Text color={liveTTScoreboardButtonTextColor}>Launch Scoreboard</Text>
                            
                        </Button>
                        {
                            process.env.NODE_ENV !== "production" ?
<Button onPress={()=>{
    setStringAsync(props.editorURL)
}} ><Text>Copy</Text></Button>
                            :
                             null
                        }
                        
                    </View>


                </Modal.Body>
            </Modal.Content>
        </Modal>
    );
}
